import api from '@/api'
import * as types from './types'

export default {
  initSendBird({ commit }, apiId) {
    commit(types.INIT_SENDBIRD, apiId)
  },
  setSearchTerm({ commit }, search) {
    if (search.for === 'user') {
      commit(types.SET_SEARCH_TERM_USER, search.text)
    } else {
      commit(types.SET_SEARCH_TERM, search.text)
    }
  },
  setPageSize({ commit }, page) {
    if (page.for === 'user') {
      commit(types.SET_PAGE_SIZE_USER, page.size)
    } else {
      commit(types.SET_PAGE_SIZE, page.size)
    }
  },
  resetChannels({ commit }) {
    commit(types.RESET_CHANNELS)
  },
  async getChannels({ commit }, searchOptions) {
    return new Promise((resolve, reject) => {
      api.getChannels(searchOptions)
        .then(response => {
          commit(types.SET_CHANNELS, response.data)
          resolve(response)
        })
    })
  },
  setChannelChecked({ commit }, data) {
    commit(types.SET_CHANNEL_CHECKED, data)
  },
  resetUsers({ commit }) {
    commit(types.RESET_USERS)
  },
  async getUsers({ commit }, searchOptions) {
    return new Promise((resolve, reject) => {
      api.getChatUsers(searchOptions)
        .then(response => {
          commit(types.SET_USERS, response.data)
          resolve(response)
        })
    })
  },
  setUserChecked({ commit }, data) {
    commit(types.SET_USER_CHECKED, data)
  },
  getUserChannels({ commit }, options) {
    return new Promise((resolve, reject) => {
      api.getChatUserChannels(options)
        .then(response => {
          commit(types.SET_CHANNELS, response.data)
          resolve(response)
        })
    })
  },
  setMessageChecked({ commit }, data) {
    commit(types.SET_MESSAGE_CHECKED, data)
  },
  resetMessageList({ commit }) {
    commit(types.RESET_MESSAGES)
  },
  addMessageToList({ commit }, message, hasmore) {
    commit(types.ADD_MESSAGE, message, hasmore)
  },
  setTyping({ commit }, channel) {
    commit(types.SET_TYPING, channel)
  },
  removeChannels({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.removeChannels(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  removeUsers({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.removeUsers(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  saveMessage({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.saveMessage(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  saveTranslatedMessage({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.saveTranslatedMessage(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  updateChannelMessageCount({ commit }, data) {
    commit(types.SET_CHANNEL_MESSAGE_COUNT, data)
  },
  getChatHistory({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.getChatHistory(id)
        .then(response => {
          commit(types.SET_MESSAGES, response.data)
          resolve(response)
        })
    })
  },
  resetRequests({ commit }) {
    commit(types.RESET_REQUESTS)
  },
  getServiceRequestsWithMessages({ commit }, search) {
    return new Promise((resolve, reject) => {
      api.getServiceRequestsWithMessages(search)
        .then(response => {
          commit(types.SET_REQUESTS, response.data)
          resolve(response)
        })
    })
  },
  saveChatMessages({ commit }, data) {
    // SaveChatHistory
    commit(types.RESET_CHANNELS)
    return new Promise((resolve, reject) => {
      api.saveChatMessages(data)
        .then(response => {
          resolve(response)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/actions.js